// On-screen keyboard (OSK) gating for kiosk devices.
//
// The on-screen numeric keypad is enabled only when the launch URL carries
// ?osk=1. This is set on the Raspberry Pi Chromium kiosks (which have no
// working software keyboard), and on nothing else. The Android kiosks and admin
// desktops never set it, so they keep using their native keyboard.
//
// The flag is persisted to localStorage so it survives in-app navigation and
// page reloads even if the query string is ever dropped. Pass ?osk=0 to clear.

const OSK_KEY = 'osk'

export function initOsk() {
  try {
    const params = new URLSearchParams(window.location.search)
    if (!params.has(OSK_KEY)) return
    const value = params.get(OSK_KEY)
    if (value === '0' || value === 'false') {
      localStorage.removeItem(OSK_KEY)
    } else {
      localStorage.setItem(OSK_KEY, '1')
    }
  } catch (e) {
    // URL parsing or localStorage unavailable; leave the OSK disabled.
  }
}

export function isOskEnabled() {
  try {
    return localStorage.getItem(OSK_KEY) === '1'
  } catch (e) {
    return false
  }
}
